export default __webpack_public_path__ + "static/media/mapCanvas.c4128c8a.jsworker";